import React, { FC } from 'react'
import { Footer as FooterComponent } from '@cse/ui'

import { FooterProps } from './footer.types'

export const Footer: FC<FooterProps> = (props) => {
  return <FooterComponent {...props} />
}
